import { render, staticRenderFns } from "./WorkerList981.vue?vue&type=template&id=0f97429c&scoped=true"
import script from "./WorkerList981.vue?vue&type=script&lang=js"
export * from "./WorkerList981.vue?vue&type=script&lang=js"
import style0 from "./WorkerList981.vue?vue&type=style&index=0&id=0f97429c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f97429c",
  null
  
)

export default component.exports